import { render, staticRenderFns } from "./Cow.vue?vue&type=template&id=e5232f74&"
import script from "./Cow.vue?vue&type=script&lang=js&"
export * from "./Cow.vue?vue&type=script&lang=js&"
import style0 from "./Cow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports